import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ProductsAPI {

    URI_V1 = "/v1/products";

    getCompanyId = () => companyAPI.getCompanyManagment().id;

    // 🔹 LISTAR
    findAll = async () => {
        return await apiService.get(
            `${this.URI_V1}?companyId=${this.getCompanyId()}`
        );
    };

    // 🔹 BUSCAR POR ID
    findById = async (productId: any) => {
        return await apiService.get(
            `${this.URI_V1}/${productId}?companyId=${this.getCompanyId()}`
        );
    };

    // 🔹 CRIAR
    create = async (data: any) => {
        return await apiService.post(
            `${this.URI_V1}?companyId=${this.getCompanyId()}`,
            data
        );
    };

    createFormData = async (formData: any) => {
        return await apiService.postFormData(
            `${this.URI_V1}/form-data?companyId=${this.getCompanyId()}`,
            formData
        );
    };

    // 🔹 ATUALIZAR
    update = async (productId: any, data: any) => {
        return await apiService.put(
            `${this.URI_V1}/${productId}?companyId=${this.getCompanyId()}`,
            data
        );
    };

    updateFormData = async (productId: any, formData: any) => {
        return await apiService.putFormData(
            `${this.URI_V1}/${productId}/form-data?companyId=${this.getCompanyId()}`,
            formData
        );
    };


    // 🔹 DELETE (soft delete no backend)
    delete = async (productId: any) => {
        return await apiService.delete(
            `${this.URI_V1}/${productId}?companyId=${this.getCompanyId()}`
        );
    };


}